import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Text } from '../../atoms/Text';
import { FieldFooter } from '../FieldFooter';
import { MediaCard } from '../MediaCard';
import { RadioButton, RadioLabel, Wrapper } from './RadioButton.styles';
export const RadioCard = /*#__PURE__*/ forwardRef(({ activeValue, hasError, label, mediaProperties, name, statusLabel, text, value, ...props }, ref)=>/*#__PURE__*/ _jsxs(MediaCard, {
        htmlFor: `${name}-${value}`,
        isActive: activeValue === value,
        mediaProperties: mediaProperties,
        children: [
            /*#__PURE__*/ _jsxs(Wrapper, {
                children: [
                    /*#__PURE__*/ _jsx(RadioButton, {
                        id: `${name}-${value}`,
                        name: name,
                        type: "radio",
                        value: value,
                        ...props,
                        $state: hasError ? 'error' : 'default',
                        ref: ref
                    }),
                    /*#__PURE__*/ _jsxs(RadioLabel, {
                        isBold: true,
                        renderAs: 'span',
                        children: [
                            label,
                            /*#__PURE__*/ _jsx(FieldFooter, {
                                fieldFooterLabel: statusLabel
                            })
                        ]
                    })
                ]
            }),
            text && /*#__PURE__*/ _jsx(Text, {
                size: "S",
                children: text
            })
        ]
    }));

//# sourceMappingURL=RadioCard.js.map